import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {LocationWithVoorraad} from '../../pot/location-with-voorraad';
import {PlugStockService} from '../plug-stock.service';
import {PlugStock} from '../plugStock';
import {SortingService} from '../../../_services/sorting.service';
import {AbstractLocationCountComponent} from '../../common/abstract-location-count.component';

@Component({
  selector: 'app-plug-controlled-count',
  templateUrl: './plug-controlled-count.component.html',
  styleUrls: ['./plug-controlled-count.component.scss']
})
export class PlugControlledCountComponent extends AbstractLocationCountComponent<PlugStock> {
  protected readonly detailRoutePrefix = '/voorraad/stek';

  constructor(
    private plugStockService: PlugStockService,
    router: Router,
    sortingService: SortingService
  ) {
    super(router, sortingService);
  }

  protected fetchLocations(): Observable<LocationWithVoorraad[]> {
    return this.plugStockService.getAllStockToBeCounted();
  }

  protected fetchStockItemById(id: number): Observable<PlugStock> {
    return this.plugStockService.getById(id);
  }

  protected updateStockItem(stock: PlugStock): Observable<PlugStock> {
    return this.plugStockService.update(stock);
  }
}
